import React from 'react';
import {
    Page,
    Card,
    Link,
    Banner,
    Button,
    Layout,
    Stack,
    Icon,
} from '@shopify/polaris';
import {
    TickMinor
} from '@shopify/polaris-icons';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../common/Helpers';
import { AppContext } from '../common/AppContext';

const PlanName = {
    "PlanBasicShopify": "Basic Shopify",
    "PlanShopify": "Shopify",
    "PlanAdvancedShopify": "Advanced Shopify",
    "PlanShopifyPlus": "Shopify Plus",
    "Development": "Development",
    "PlanLiteShopify": "Lite",
}

class PlansPage extends React.Component {

    state = {
        storeInfo: {}
    };

    render() {

        const isDev = this.context.tierName === "Development";
        let planText = PlanName[this.context.tierName];

        if (planText == null || planText === "") {
            planText = "Legacy";
        }

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Plans</title>
                </Helmet>
                <Page title="Tag Genie Plan">
                    <Layout>
                        {isDev && <Layout.Section>
                            <Banner
                                title="Development Store Plan"
                                status="info"
                                onDismiss={() => { }}
                            >
                                <p>You are on development store plan with all features enabled.</p>
                            </Banner>
                        </Layout.Section>
                        }
                        <Layout.Section>
                            <Card title="What You Get" sectioned>
                                <Stack vertical spacing="tight">
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Best Tag Management App for Shopify</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Unlimited operations</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>All features</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Premium support</p>
                                        </Stack>
                                    </Stack.Item>
                                </Stack>
                                <br />
                                <p>For detailed list of all features and pricing information please visit our <Link url="https://taggenieapp.com/pricing">Pricing page</Link></p>
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Plan">
                                <Card.Section>
                                    <p>Your store is on the <b>{planText}</b> Tag Genie plan.</p>
                                    <br />
                                    <p>We also encourage you to checkout our <Link external={true} url='https://taggenieapp.com/pricing'><b>Feels Good</b> pricing policy.</Link></p>
                                    <p>If you feel that the pricing plan is not appropriate please <Button plain onClick={this.onOpenChat}>chat with us</Button> or reach us at <Link url='mailto:support@taggenieapp.com'>support@taggenieapp.com</Link>.</p>

                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    handleSubscribe(planName) {
        fetch(`api/storeConnections/changePlanRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ "planTier": planName })
        }).then(response => response.json())
            .then((data) => {

                if (data.confirmationUrl != null) {
                    window.location.href = data.confirmationUrl;
                }
            });
    }

    componentDidMount() {
    }
}

PlansPage.contextType = AppContext;

export default PlansPage;